import { IconLayerGray, IconLayers, IconPcLine, IconSecurity } from '@assets/images/icon';
import { IconComputer, IconGuarantee } from '@assets/images/main';
import {
  IconEdgeAiInv,
  IconL2SwitchInv,
  IconOsEdgeOff,
  IconOsEdgeOn,
  IconOsServerInv,
  IconOsServerOff,
  IconOsServerOn,
  IconOsSwitchOff,
  IconOsSwitchOn,
} from '@assets/images/main/icon';
import {
  IconBlueCircle,
  IconBlueCycle,
  IconBlueDevelop,
  IconBlueFigure,
  IconBluePlus,
  IconBluePower,
  IconBlueScan,
  IconBlueShield,
} from '@assets/images/main/icon/blue';
import { osBanner, osDownloadD, osDownloadM, osDownloadT, osLogoDesktop, osLogoMobile, osLogoTablet } from '@assets/images/main/os/bannerImg';
import {
  OsSectionDesktop1,
  OsSectionTablet1,
  OsSectionMobile1,
  OsSectionDesktop2,
  OsSectionTablet2,
  OsSectionMobile2,
  OsSectionDesktop3,
  OsSectionTablet3,
  OsSectionMobile3,
  OsSectionDesktop4,
  OsSectionTablet4,
  OsSectionMobile4,
  OsSectionDesktop5,
  OsSectionTablet5,
  OsSectionMobile5,
  OsSectionDesktop6,
  OsSectionTablet6,
  OsSectionMobile6,
  OsSectionDesktop7,
  OsSectionTablet7,
  OsSectionMobile7,
  OsSectionDesktop8,
  OsSectionTablet8,
  OsSectionMobile8,
  OsSectionDesktop9,
  OsSectionTablet9,
  OsSectionMobile9,
  OsSectionDesktop10,
  OsSectionTablet10,
  OsSectionMobile10,
  OsSectionDesktop11,
  OsSectionTablet11,
  OsSectionMobile11,
  OsSectionDesktop12,
  OsSectionTablet12,
  OsSectionMobile12,
  OsSectionDesktop13,
  OsSectionTablet13,
  OsSectionMobile13,
  OsSectionDesktop14,
  OsSectionTablet14,
  OsSectionMobile14,
  OsSectionDesktop15,
  OsSectionTablet15,
  OsSectionMobile15,
  OsTextImg1,
  OsTextImg2,
  OsTextImg3,
  OsTextImg4,
  OsSectionDesktop16,
  OsSectionTablet16,
  OsSectionMobile16,
  OsSectionDesktop17,
  OsSectionTablet17,
  OsSectionMobile17,
  OsSectionDesktop18,
  OsSectionTablet18,
  OsSectionMobile18,
  OsSectionDesktop19,
  OsSectionTablet19,
  OsSectionMobile19,
  OsSectionDesktop20,
  OsSectionTablet20,
  OsSectionMobile20,
} from '@assets/images/main/os/section';

export default {
  bannerData: [
    {
      icon: IconOsServerOn,
      iconInv: IconOsServerInv,
      iconOff: IconOsServerOff,
      image: '',
      iconText: 'ORBRO Server',
      sub: 'New',
      link: '/os/server',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconEdgeAiInv,
      iconOff: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge RTLS',
      sub: 'New',
      link: '/os/rtls',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconEdgeAiInv,
      iconOff: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/os/ai',
    },
    {
      icon: IconOsSwitchOn,
      iconInv: IconL2SwitchInv,
      iconOff: IconOsSwitchOff,
      image: '',
      iconText: 'L2 Switch',
      sub: 'New',
      link: '/os/switch',
    },
  ],

  title: '여러 공간과 다양한 디바이스,<br/>한눈에 연결되는 디지털 플랫폼',
  desc: '오브로 서버에 기본 내장된 ORBRO OS로, 공간·기기·사용자를 한 화면에서 관리하세요.<br/>어디서든 실시간 정보를 확인하고 안전한 운영을 지원합니다.',
  osLogo: {
    desktop: osLogoDesktop,
    tablet: osLogoTablet,
    mobile: osLogoMobile,
  },

  bannerImg: osBanner,

  section: {
    title: 'ORBRO OS는 오직<br/>ORBRO Server와 ORBRO Edge에서만 구동됩니다.',
    desc: '현장의 규모와 상황에 맞춰, 소규모 공간에서는 ORBRO Edge, 대규모 환경에서는 ORBRO Server를 통해<br/>공간·기기·사용자를 한 화면에서 통합 관리할 수 있습니다.',
    tag: [
      {
        icon: IconPcLine,
        title: '24시간 안전 운영',
        desc: '위치 추적이나 AI 분석 등의 작업을 끊김 없이 수행할 수 있는 견고한 하드웨어 설계.',
      },
      {
        icon: IconSecurity,
        title: '외부 클라우드 없이 안전하게',
        desc: '데이터를 외부 클라우드로 보내지 않고, 사내망·보안망 내부에서 처리해 민감 정보 보호.',
      },
      {
        icon: IconLayers,
        title: '장비·센서 무제한 연결',
        desc: '무선 위치 추적 태그, 센서, 카메라 등 다양한 디바이스를 계속 추가해도 안정적으로 운영.',
      },
    ],
    img: {
      desktop: OsSectionDesktop1,
      tablet: OsSectionTablet1,
      mobile: OsSectionMobile1,
    },
  },

  section1: {
    img: OsTextImg1,
    tag: '실시간 모니터링',
    title: '위치 · 영상 · 센서까지,<br/>실시간으로 한눈에',
    desc: 'IP/PTZ 카메라와 온습도·공기질·화재 감지 센서를 통합 확인.<br/>이상 상황이 감지되면 즉시 푸시 알림으로 대응을 돕습니다.',
    box: [
      {
        size: 1,
        title: '이벤트 알림 & 실시간 위치 추적 모니터링',
        desc: '건물 내 구역 출입·이벤트를 실시간 파악하고, RTLS로 작업자·방문자 위치를 직관적으로 확인하는 모니터링 화면입니다. 특정 조건 발생 시 즉각 알림을 받아 보안·안전과 업무 대응을 강화할 수 있습니다. ',
        img: {
          desktop: OsSectionDesktop2,
          tablet: OsSectionTablet2,
          mobile: OsSectionMobile2,
        },
      },
      {
        size: 2,
        title: '실시간 카메라 모니터링',
        desc: '등록된 카메라의 실시간 영상을 확인하며, 카메라 상태·온라인 여부·구동 시간을 한눈에 파악할 수 있습니다. 장애 발생 시 즉각 점검이 가능하고, ORBRO AI 기능을 통해 실시간 위치 추적(RTLS)과 물체 감지 등 지능형 분석을 수행합니다.',
        img: {
          desktop: OsSectionDesktop3,
          tablet: OsSectionTablet3,
          mobile: OsSectionMobile3,
        },
      },
      {
        size: 2,
        title: '실시간 센서 모니터링',
        desc: '공기질 센서는 온도·습도·미세먼지 등 환경 데이터를 실시간 수집·분석해 한눈에 확인하고 빠르게 대응하도록 돕습니다. 직관적 그래프와 대시보드를 통해 공기질 변화를 쉽게 파악하고, 기기 상태·설치 위치도 통합 관리가 가능합니다.',
        img: {
          desktop: OsSectionDesktop4,
          tablet: OsSectionTablet4,
          mobile: OsSectionMobile4,
        },
      },
    ],
  },

  section2: {
    img: OsTextImg2,
    tag: '공간관리',
    title: '공간을 디지털로 옮기다,<br/>가상과 현실의 경계를 지우다',
    desc: '빌딩·층 정보를 등록하고 기기의 위치를 지정하면, 실제 공간을 그대로 디지털 트윈으로 재현할 수 있습니다.<br/>또한 3D 도면을 업로드하면 더욱 정밀한 환경을 구축할 수 있습니다.',
    box: [
      {
        size: 2,
        title: '공간관리',
        desc: '간단한 조작만으로 건물 층별 도면 이미지를 업로드하고 축척을 입력해, 실제 공간 크기와 동일한 디지털 맵을 생성·관리할 수 있습니다. 이를 통해 각 구역에 대한 정확한 위치 파악이 가능해지며, 카메라·센서 등 다양한 장비를 직관적으로 배치하고 효율적으로 운영할 수 있습니다.',
        img: {
          desktop: OsSectionDesktop5,
          tablet: OsSectionTablet5,
          mobile: OsSectionMobile5,
        },
      },
      {
        size: 2,
        title: '구역관리',
        desc: '도면 상에 원하는 영역을 직접 지정(존 설정)하고, 추적할 객체(사람·장비·차량 등)를 선택해 해당 구역의 데이터를 효과적으로 축적·관리할 수 있습니다. 특정 구역에 대한 출입 정보나 이벤트 발생 현황 등을 한눈에 파악하고, 이를 바탕으로 공간 운영·보안·안전 관리를 한층 더 체계적으로 관리 할 수 있습니다.',
        img: {
          desktop: OsSectionDesktop6,
          tablet: OsSectionTablet6,
          mobile: OsSectionMobile6,
        },
      },
      {
        size: 1,
        title: '3D정밀 지도',
        desc: '2D 도면보다 더 풍부한 공간 정보를 제공하기 위해 3D 파일을 업로드해, 건물 구조와 배치를 보다 정확하게 확인할 수 있습니다. 층간 높이나 시설물 배치 등 세부 요소를 직관적으로 파악함으로써, 공간 활용도와 안전성을 높이는 데 유용합니다.',
        img: {
          desktop: OsSectionDesktop7,
          tablet: OsSectionTablet7,
          mobile: OsSectionMobile7,
        },
      },
    ],
  },

  section3: {
    img: OsTextImg3,
    tag: '애플리케이션 기능',
    title: '기록하고, 분석하고,<br/>자동으로 대응하는 스마트 운영.',
    desc: '동선을 녹화·재생해 사후 분석하고, Heatmap으로 이동 패턴을 시각화하며,<br/>SOP로 비상 상황도 자동화된 프로세스로 처리합니다',
    box: [
      {
        size: 1,
        title: 'Heatmap',
        desc: 'Heatmap 기능은 저장된 위치 추적 데이터를 바탕으로 특정 기간 동안의 유동 인구나 방문 패턴을 시각화해 보여줍니다. 원하는 날짜·시간대를 선택하면, 사람들이 주로 모이는 구역이나 관심도가 높은 공간을 한눈에 파악할 수 있습니다. 이를 통해 공간 활용 방안 수립부터 안전·보안 관리, 마케팅 전략 수립 등 다양한 분야에서 유용한 인사이트를 얻을 수 있습니다.',
        img: {
          desktop: OsSectionDesktop8,
          tablet: OsSectionTablet8,
          mobile: OsSectionMobile8,
        },
      },
      {
        size: 1,
        title: 'Record',
        desc: 'Record 기능은 위치 추적 데이터를 녹화해, 특정 시점의 이동 동선을 되돌려 볼 수 있도록 지원합니다. 원하는 기간·대상을 선택해 재생하면서 움직임을 상세히 확인하고, 이를 통해 보안·안전 관리는 물론, 동선 최적화 및 효율적인 시설 운영까지 다각도로 활용할 수 있습니다.',
        img: {
          desktop: OsSectionDesktop9,
          tablet: OsSectionTablet9,
          mobile: OsSectionMobile9,
        },
      },
      {
        size: 2,
        title: 'SOP 시나리오 설정',
        desc: '특정 알람이나 이벤트 발생 시 수행해야 할 표준 운영 절차(SOP)를 자유롭게 구성하고, 단계별 액션을 자동화할 수 있는 기능입니다. 상황 발생 조건, 대응 단계, 담당자 지정, SMS 발송 여부 등을 간편하게 설정하여, 실제 현장에서 누구나 빠르고 일관된 조치를 취할 수 있습니다. ',
        img: {
          desktop: OsSectionDesktop10,
          tablet: OsSectionTablet10,
          mobile: OsSectionMobile10,
        },
      },
      {
        size: 2,
        title: 'SOP 발생',
        desc: 'SOP(표준 운영 절차)가 발동되면, 발생 지역·시간·조건 등 핵심 정보와 함께 단계별 조치 사항을 순차적으로 안내하고, SMS 등 커뮤니케이션 기능을 통해 담당자와 즉시 공유할 수 있습니다. ',
        img: {
          desktop: OsSectionDesktop11,
          tablet: OsSectionTablet11,
          mobile: OsSectionMobile11,
        },
      },
    ],
  },

  section4: {
    img: OsTextImg4,
    tag: '관리자 설정',
    title: '사용자·그룹·기기를<br/>한곳에서 손쉽게 제어.',
    desc: '관리자/사용자 계정, 알림 대상 그룹, 카메라·센서 등<br/>모든 기기를 직관적으로 추가·편집·삭제할 수 있습니다.',
    box: [
      {
        size: 2,
        title: '사용자 관리',
        desc: '사용자 관리 기능을 통해 각 사용자의 계정 유형, 권한 범위, 연락처 정보를 손쉽게 설정하고 유지할 수 있습니다.',
        img: {
          desktop: OsSectionDesktop12,
          tablet: OsSectionTablet12,
          mobile: OsSectionMobile12,
        },
      },
      {
        size: 2,
        title: '그룹관리',
        desc: '그룹 관리 기능을 통해 사용자들을 쉽게 분류하고, 조직·팀 단위로 묶어 체계적으로 운영할 수 있습니다.',
        img: {
          desktop: OsSectionDesktop13,
          tablet: OsSectionTablet13,
          mobile: OsSectionMobile13,
        },
      },
      {
        size: 2,
        title: '조건 알림 관리',
        desc: '조건 알림 관리 기능을 통해 특정 상황(화재 감지, 이상 가스 발생, 사람 진입 등)에 대한 알람 조건과 위험도를 설정할 수 있습니다. 위험 수준에 따라 맞춤형 메시지를 자동 발송하여, 관리자와 담당자가 문제 상황을 즉시 파악하고 신속하게 대응할 수 있습니다.',
        img: {
          desktop: OsSectionDesktop14,
          tablet: OsSectionTablet14,
          mobile: OsSectionMobile14,
        },
      },
      {
        size: 2,
        title: '기기 관리',
        desc: '카메라, 센서, 태그 등 여러 종류의 디바이스를 한곳에 등록하고 편집할 수 있는 통합 관리 기능입니다. 각 기기의 상태·배터리·네트워크 정보를 직관적으로 확인하며, 필요한 설정도 실시간으로 변경할 수 있어 운영 효율을 높일 수 있습니다.',
        img: {
          desktop: OsSectionDesktop15,
          tablet: OsSectionTablet15,
          mobile: OsSectionMobile15,
        },
      },
    ],
  },

  section5: {
    img: OsTextImg4,
    tag: '',
    title: '무선·영상·GPS·출입·산업용IoT,<br/>하나의 플랫폼에서 모두 연결',
    desc: 'ORBRO OS는 위치 추적부터 출입제어, 산업용 IoT센서까지<br/>하나의 플랫폼으로 통합 지원합니다. 자세한 라인업을 확인해 보세요.',
    box: [
      {
        size: 1,
        title: '전파 위치추적',
        desc: 'BLE, AoA, UWB 등 무선 통신 기반 위치 추적',
        img: {
          desktop: OsSectionDesktop16,
          tablet: OsSectionTablet16,
          mobile: OsSectionMobile16,
        },
        link: '/rtls',
      },
      {
        size: 2,
        title: '영상 위치 추적',
        desc: 'AI 기반 영상을 통한 객체 추적',
        img: {
          desktop: OsSectionDesktop17,
          tablet: OsSectionTablet17,
          mobile: OsSectionMobile17,
        },
        link: '/camera',
      },
      {
        size: 2,
        title: '야외 위치 추적',
        desc: '차량 및 야드 위치추적',
        img: {
          desktop: OsSectionDesktop18,
          tablet: OsSectionTablet18,
          mobile: OsSectionMobile18,
        },
        link: '/outdoor/gps',
      },
      {
        size: 2,
        title: '출입 시스템',
        desc: '자동문, 얼굴인식 등 출입 제어',
        img: {
          desktop: OsSectionDesktop19,
          tablet: OsSectionTablet19,
          mobile: OsSectionMobile19,
        },
        link: '/access',
      },
      {
        size: 2,
        title: 'IIoT',
        desc: '공기질 · 일산화탄소센서, LoRA게이트웨이, 로봇 등을 연동',
        img: {
          desktop: OsSectionDesktop20,
          tablet: OsSectionTablet20,
          mobile: OsSectionMobile20,
        },
        link: '/iot/LoRAGateway',
      },
    ],
  },

  downloadSection: {
    title: '웹 · 모바일 · 태블릿,<br/>어디서든 안전한 운영',
    desc: 'ORBRO OS는 PC 브라우저는 물론, iOS·Android 앱과 태블릿에서도<br/>동일한 인터페이스를 제공합니다.',
    ios: 'iOS 다운로드',
    aos: 'Android 다운로드',
    img: {
      desktop: osDownloadD,
      tablet: osDownloadT,
      mobile: osDownloadM,
    },
  },
  function: {
    title: '그 밖의 다양한 기능들',
    box: [
      {
        icon: IconBlueScan,
        title: '실시간 데이터 분석 및 시각화',
        desc: 'OS는 수집된 데이터를 분석하고 시각화하여 사용자에게 제공할 수 있습니다. 이를 통해 디지털트윈을 통해 수집된 정보를 실시간으로 이해하고 활용할 수 있습니다.',
      },
      {
        icon: IconBlueShield,
        title: '보안 및 개인 정보 보호',
        desc: '디지털트윈을 보호하기 위한 강력한 보안 기능을 제공할 것입니다. 민감한 정보에 대한 액세스를 제한하고 데이터의 무단 수정을 방지하여 보안 문제를 최소화할 수 있습니다.',
      },
      {
        icon: IconBlueDevelop,
        title: '개발자 친화적',
        desc: '개발자들이 쉽게 디지털트윈 기능을 활용하고 확장할 수 있도록 개발되었을 것입니다. 강력한 API 및 개발 도구를 제공하여 새로운 애플리케이션 및 서비스를 개발할 수 있습니다.',
      },
      {
        icon: IconBlueFigure,
        title: '인공지능 통합',
        desc: '인공지능(AI) 기술을 통합하여 디지털트윈을 더욱 지능적으로 관리하고 최적화할 수 있습니다. AI 알고리즘을 사용하여 데이터를 분석하고 예측 모델을 구축하여 시스템의 성능을 향상시킬 수 있습니다.',
      },
      {
        icon: IconBluePower,
        title: '환경 모니터링 및 지능형 에너지 관리',
        desc: '환경 모니터링 센서를 통합하여 에너지 소비 및 자원 사용을 최적화할 수 있습니다. 실시간으로 환경 상태를 모니터링하고 필요에 따라 자동으로 시스템을 조절하여 에너지 효율성을 극대화할 수 있습니다.',
      },
      {
        icon: IconBlueCycle,
        title: '자동화 및 스마트 제어',
        desc: '디지털트윈을 통해 수집된 정보를 기반으로 자동화된 결정을 내릴 수 있습니다. 예를 들어, 특정 조건이 충족되면 자동으로 장치를 제어하거나 프로세스를 실행할 수 있습니다.',
      },
      {
        icon: IconBluePlus,
        title: '사용자 정의 가능한 인터페이스',
        desc: '사용자가 필요에 따라 인터페이스를 사용자 정의할 수 있는 기능을 제공할 것입니다. 사용자는 디지털트윈을 모니터링하고 제어하기 위한 대시보드나 애플리케이션을 자유롭게 구성할 수 있습니다.',
      },
      {
        icon: IconBlueCircle,
        title: '생태계 확장성',
        desc: '개발자 및 기업이 자체적으로 애드온이나 플러그인을 개발하여 시스템을 확장할 수 있는 생태계를 구축할 수 있습니다. 이를 통해 다양한 산업 및 응용 분야에 대한 커스터마이징된 솔루션을 제공할 수 있습니다.',
      },
    ],
  },

  faqTitle: '자주 묻는 질문',

  beacon: {
    index: 4,
  },
  rtls: {
    index: 1,
  },
  camera: {
    index: 2,
  },
  access: {
    index: 3,
  },
  sensor: {
    index: 4,
  },
  integration: {
    index: 1,
  },
};
